// extracted by mini-css-extract-plugin
export var emptyState = "account-empty-state-module--empty-state--27ViH";
export var emptyStateBody = "account-empty-state-module--empty-state-body--arlDI";
export var emptyStateImage = "account-empty-state-module--empty-state-image--TK0I+";
export var emptyStateText = "account-empty-state-module--empty-state-text--88cy2";
export var emptyStateTitle = "account-empty-state-module--empty-state-title--QBRQb";